import { Grid } from '@mui/material';
import { memo, useMemo } from 'react';
import { PmiTextField } from 'shell/components/shared/text-field';
import { useFormikContext } from 'formik';
import { Head, ViewStepVM } from 'civil-status/view-models/step-form';
import { getValueStateNotification } from 'civil-status/constants/states-notifications';

interface FormProps {
  stateNotification?: string;
}

const FormComponent = ({ stateNotification }: FormProps): React.ReactElement => {
  const formContext = useFormikContext<ViewStepVM>();

  const values: Head = useMemo(() => {
    return formContext.values?.head || {};
  }, [formContext.values]);

  return (
    <Grid container spacing={2} item>
      <Grid item xs={12} md={3}>
        <PmiTextField
          label="ID Ansc"
          aria-label="ID Ansc"
          id="idAnsc"
          fullWidth
          disabled
          value={values.idAnsc || ''}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <PmiTextField
          label="Comune"
          aria-label="Comune"
          id="municipality"
          fullWidth
          disabled
          value={values.municipality || ''}
        />
      </Grid>
      <Grid item xs={12} md={2}>
        <PmiTextField
          label="Data formazione"
          aria-label="Data formazione"
          id="dateFormation"
          fullWidth
          disabled
          value={values.dateFormation || ''}
        />
      </Grid>
      {values.effectiveDate ? (
        <Grid item xs={12} md={2}>
          <PmiTextField
            label="Data decorrenza"
            aria-label="Data decorrenza"
            id="effectiveDate"
            fullWidth
            disabled
            value={values.effectiveDate || ''}
          />
        </Grid>
      ) : undefined}
      <Grid item xs={12} md={2}>
        <PmiTextField
          label="Registro"
          aria-label="Registro"
          id="register"
          fullWidth
          disabled
          value={values.register || ''}
        />
      </Grid>
      <Grid item xs={12} md={2}>
        <PmiTextField
          label="Tipo contenuto"
          aria-label="Tipo contenuto"
          id="typeContent"
          fullWidth
          disabled
          value={values.typeContent || ''}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <PmiTextField
          label={stateNotification ? 'Stato atto' : 'Stato'}
          aria-label={stateNotification ? 'Stato atto' : 'Stato'}
          id="state"
          fullWidth
          disabled
          value={values.state || ''}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <PmiTextField
          label="Codice Usecase"
          aria-label="Codice Usecase"
          id="idUC"
          fullWidth
          disabled
          value={values.idUC || ''}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <PmiTextField
          label="Descrizione Usecase"
          aria-label="Descrizione Usecase"
          id="descriptionsUC"
          fullWidth
          disabled
          value={values.descriptionsUC || ''}
        />
      </Grid>
      {stateNotification ? (
        <Grid item xs={12} md={3}>
          <PmiTextField
            label="Stato notifica"
            aria-label="Stato notifica"
            id="state"
            fullWidth
            disabled
            value={getValueStateNotification(stateNotification)}
          />
        </Grid>
      ) : undefined}
    </Grid>
  );
};

FormComponent.displayName = 'Form Head component';

const Form = memo(FormComponent);

export default Form;
